import * as React from "react";
import {
  Paper,
  IconButton,
  Box,
  Pagination,
  MenuItem,
  Grid,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  Select,
  Stack,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { connect } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import { centered_flex_box } from "../../app/components/Styles";
import {
  acceptTicketRequest,
  fulfillTicketRequest,
  generateRequestDetails,
  getOrders,
  getTicketRequestsAdmin,
  rejectTicketRequest,
} from "../../app/store/actions/adminActions";
import { uploadFile } from "react-s3";
import { config } from "../../app/config";
import { payTicketRequest } from "../../app/store/actions/userActions";
import { useParams } from "react-router-dom";
import { OrderRow } from "./components";
import {
  PlatformPage,
  PlatformPageHeader,
  PlatformCard,
  PlatformButton,
  PlatformEmptyState,
  PlatformLoadingBlock,
} from "../../app/components/platform";
import {
  platformFilterSelectSx,
  platformSearchInputSx,
  platformTableSx,
  platformTableContainerSx,
  platformColors,
} from "../../app/components/tickitPlatformTheme";


export const TicketRequests = ({
  token,
  orders,
  isLoading,
  getOrders
}) => {
  const eventId = useParams().id;
  const role = token.split(" ")[0];

  const initialState = {
    status: "Pending",
    event: eventId,
    page: 1,
    limit: 50,
  };

  const [action, setAction] = React.useState(false);

  React.useEffect(() => {
    getOrders(formData);
  }, [action]);

  const [formData, setFormData] = React.useState(initialState);

  const handleClearFilter = (event) => {
    setFormData(initialState);
    getOrders(initialState);
  };

  const { status, search, page } = formData;

  const [dialogs, setDialogs] = React.useState({});

  const handlePageChange = (event, value) => {
    setFormData({ ...formData, page: value });
    getOrders({ ...formData, page: value });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSearchFilter = (event) => {
    getOrders(formData);
  };

  return (
    <PlatformPage>
      <PlatformPageHeader
        title={eventId ? "Event orders" : "Order requests"}
        subtitle="Filter and manage ticket orders"
      />

      <PlatformCard title="Filters" sx={{ mb: 2.5 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel id="status-label">Status</InputLabel>
              <Select
                labelId="status-label"
                id="status"
                label="Status"
                name="status"
                value={status}
                onChange={handleChange}
                sx={platformFilterSelectSx}
              >
                <MenuItem value={"Successful"}>Successful</MenuItem>
                <MenuItem value={"Declined"}>Declined</MenuItem>
                <MenuItem value={"Pending"}>Pending</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={5}>
            <FormControl fullWidth variant="outlined">
              <OutlinedInput
                id="search"
                name="search"
                autoComplete="search"
                value={search || ""}
                onChange={handleChange}
                placeholder="Search for Event Requests"
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton onClick={handleSearchFilter} edge="end">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                }
                sx={platformSearchInputSx}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} justifyContent="flex-end">
              <PlatformButton variant="ghost" onClick={handleClearFilter}>
                Clear Filters
              </PlatformButton>
              <PlatformButton variant="primary" onClick={handleSearchFilter}>
                Apply Filters
              </PlatformButton>
            </Stack>
          </Grid>
        </Grid>
      </PlatformCard>

      <Paper
        elevation={0}
        sx={{
          p: { xs: 2, sm: 3 },
          borderRadius: 2,
          backgroundColor: "var(--platform-surface)",
          border: "1px solid",
          borderColor: "#e0e0e0",
        }}
      >
        {!isLoading ? (
          orders?.docs?.length > 0 ? (
            <TableContainer sx={platformTableContainerSx}>
              <Table sx={{ minWidth: 650, ...platformTableSx }} aria-label="orders table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Name</TableCell>
                    <TableCell align="left">Event</TableCell>
                    <TableCell align="left">Tickets</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Info</TableCell>
                    <TableCell align="left">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orders?.docs?.map((order) => (
                    <OrderRow key={order._id} action={action} setAction={setAction} order={order} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <PlatformEmptyState title="No orders found" description="Try adjusting your filters." />
          )
        ) : (
          <PlatformLoadingBlock />
        )}
        <Box sx={{ ...centered_flex_box, mt: 3 }}>
          <Pagination
            count={orders?.pages || 1}
            page={page}
            onChange={handlePageChange}
            sx={{
              "& .Mui-selected": {
                backgroundColor: `${platformColors.brandPale} !important`,
                color: platformColors.brand,
              },
            }}
          />
        </Box>
      </Paper>
    </PlatformPage>
  );
};

const mapStateToProps = (state) => ({
  token: state?.auth?.token,
  orders: state?.records?.results?.orders,
  isLoading: state?.records?.isLoading,
});

const mapDispatchToProps = {
  getTicketRequestsAdmin,
  generateRequestDetails,
  acceptTicketRequest,
  fulfillTicketRequest,
  rejectTicketRequest,
  getOrders
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketRequests);
